module.exports = __webpack_public_path__ + "static/media/remove.f0584cb5.svg";